/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateMultipleAllocationsInput = {
    projectId?: string | null | undefined;
    idleTimeId?: string | null | undefined;
    projectGroupId?: string | null | undefined;
    allocations?: Array<CreateAllocationInputType | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateAllocationInputType = {
    personId?: string | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
    monday?: number | null | undefined;
    tuesday?: number | null | undefined;
    wednesday?: number | null | undefined;
    thursday?: number | null | undefined;
    friday?: number | null | undefined;
    saturday?: number | null | undefined;
    sunday?: number | null | undefined;
    description?: string | null | undefined;
    idleTimeId?: string | null | undefined;
    projectId?: string | null | undefined;
    projectGroupId?: string | null | undefined;
    isSoft?: boolean | null | undefined;
};
export type createMultipleAllocationsMutationVariables = {
    input: CreateMultipleAllocationsInput;
};
export type createMultipleAllocationsMutationResponse = {
    readonly createMultipleAllocations: {
        readonly project: {
            readonly id: string;
        } | null;
    } | null;
};
export type createMultipleAllocationsMutation = {
    readonly response: createMultipleAllocationsMutationResponse;
    readonly variables: createMultipleAllocationsMutationVariables;
};



/*
mutation createMultipleAllocationsMutation(
  $input: CreateMultipleAllocationsInput!
) {
  createMultipleAllocations(input: $input) {
    project {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMultipleAllocationsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMultipleAllocationsPayload",
    "kind": "LinkedField",
    "name": "createMultipleAllocations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMultipleAllocationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMultipleAllocationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createMultipleAllocationsMutation",
    "operationKind": "mutation",
    "text": "mutation createMultipleAllocationsMutation(\n  $input: CreateMultipleAllocationsInput!\n) {\n  createMultipleAllocations(input: $input) {\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8d0b603fa83afa6afbee98fa74a1ae00';
export default node;
